import React from "react";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import { STEPS } from "./CampaignWizard.constants";

const WizardFooter = ({
  currentStep,
  onBack,
  onNext,
  onSubmit,
  canProceed,
  handleSubmit,
  loading,
}) => {
  return (
    <div className="wizard-footer">
      <button
        type="button"
        className="popup-cancel-btn"
        onClick={onBack}
        disabled={currentStep === 0}
      >
        <ChevronLeft size={16} /> Back
      </button>

      {currentStep < STEPS.length - 1 ? (
        <button
          type="button"
          className="popup-add-btn-filter"
          onClick={onNext}
          disabled={!canProceed()}
        >
          Next <ChevronRight size={16} />
        </button>
      ) : (
        <button
          type="button"
          className="proceed-btn popup-add-btn-filter"
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        >
          {loading ? "Creating..." : <><Save size={16} /> Save Campaign</>}
        </button>
      )}
    </div>
  );
};

export default WizardFooter;
